<template>
  <iq-card
    class-name="iq-card-block iq-card-stretch"
    body-class=""
    class="p-3"
    id="quickQuotePage"
  >
    <div class="row">
      <div class="col-12">
        <h4 class="text-info fw-600 mb-3">Generate Invoices</h4>
      </div>
    </div>
    <b-row>
      <div class="col-12">
        <div>
          <label for="paginate" class="mb-0">Stake holder type</label>
          <select v-model="stakeHolderType" class="form-control sits_select">
            <option value="">Select</option>
            <option value="de">Dealer</option>
            <option value="rp">Referral Partner</option>
          </select>
          <div class="invalid-feedback" v-if="errors.stakeHolderType">
            {{ errors.stakeHolderType[0] }}
          </div>
        </div>
      </div>

      <b-col lg="12" md="12" sm="12">
        <div class="d-flex">
          <div class="pr-2">
            <label class="" for="noteOnOtherIncome">Year</label>
            <datePicker
              type="year"
              :editable="true"
              value-type="YYYY"
              format="YYYY"
              placeholder="YYYY"
              v-model="invoiceYear"
            >
            </datePicker>
            <div class="invalid-feedback" v-if="errors.invoiceYear">
              {{ errors.invoiceYear[0] }}
            </div>
          </div>
          <div class="pl-2">
            <label class="" for="noteOnOtherIncome">Month</label>
            <datePicker
              type="month"
              :editable="true"
              format="MM"
              placeholder="MM"
              value-type="MM"
              v-model="invoiceMonth"
            >
            </datePicker>
            <div class="invalid-feedback" v-if="errors.invoiceMonth">
              {{ errors.invoiceMonth[0] }}
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="row">
      <div class="col-12 text-right mt-3">
        <button class="btn btn-primary btn-sm mr-2" @click="fnGenerate()">
          Process
        </button>
      </div>
    </div>
  </iq-card>
</template>
  <script>
import datePicker from 'vue2-datepicker'
import * as invoiceService from '../../../services/invoice.service'
import * as messageService from '../../../services/message.service'

export default {
  name: 'InvoiceGenerate',
  components: {
    datePicker
  },
  data() {
    return {
      errors: {},
      invoiceYear: '',
      invoiceMonth: '',
      stakeHolderType: '',
      loading: false
    }
  },
  methods: {
    async fnGenerate() {
      try {
        let dataObj = {
          invoiceYear: this.invoiceYear,
          invoiceMonth: this.invoiceMonth,
          stakeHolderType: this.stakeHolderType
        }

        this.errors = {}
        const res = await invoiceService.generate(dataObj)

        if (res.data.status_code == 200) {
          messageService.fnSweetAlertSuccessToast(
            'Invoices generated',
            'successfully '
          )
        }
        this.rptData = res.data
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Invoices generated',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Invoices generated',
              'Something wrong'
            )
            break
        }
      }
    }
  }
}
</script>
  
  <style>
.iq-card-body {
  flex: unset;
}
@page {
  /* size: A4 portrait;  */
  width: 210mm;
  height: 280mm;
  margin: 20px 20px 20px 20px;
  padding: 0;
}
@media print {
  body * {
    visibility: hidden;
  }
  #quickQuotePage {
    display: none !important;
  }
  #quickQuotePage2 {
    display: none !important;
  }
  #printMe,
  #printMe * {
    visibility: visible !important;
  }
  #printMe {
    position: absolute !important;
    left: 0px !important;
    top: 0px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
  }
}
</style>
  